import React, { useState } from "react";
import styled from "styled-components";

import { Button } from "../../theme";
import Modal from "../modal/Modal";

const Container = styled.div`
  padding: 20px;

  p {
    margin-bottom: 1.4rem;
  }

  div {
    margin-top: 20px;
    text-align: center;
  }
`;

function PasswordResetModal() {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => setIsOpen(false);

  return (
    <Modal
      isOpen={isOpen}
      title="Mot de passe modifié"
      contentLabel="Mot de passe modifié"
      handleClose={handleClose}
      hideButton
    >
      <Container>
        <p>Votre mot de passe a bien été modifié.</p>
        <p>
          Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.
        </p>
        <div>
          <Button onClick={handleClose}>Je me connecte</Button>
        </div>
      </Container>
    </Modal>
  );
}

export default PasswordResetModal;
